module.exports = __webpack_public_path__ + "img/bxjx.ca2f72ec.png";